module.exports = __webpack_public_path__ + "static/img/title.89a64b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/title.png
// module id = 05xs
// module chunks = 1